<div fxLayout="row">
  <button mat-icon-button color="primary"
          [matTooltip]="'Edit ' + this.tooltipName"
          [disabled]="editDisabled || editMode"
          (click)="editClicked()">
    <mat-icon>edit</mat-icon>
  </button>
  <button mat-icon-button color="accent"
          *ngIf="editMode" [disabled]="saveDisabled || (value === undefined) || (value === origVal)"
          [matTooltip]="'Save ' + this.tooltipName"
          (click)="saveClicked()">
    <mat-icon>save</mat-icon>
  </button>
  <button mat-icon-button color="warn"
          *ngIf="editMode" [disabled]="cancelDisabled"
          [matTooltip]="'Cancel editing ' + this.tooltipName"
          (click)="cancelClicked()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
